export enum TranslationApi {
    GoogleTranslateApi = 1,
    LindatApi = 2,
}